import * as constants from '../constants';

export default function (state = [], action) {
  switch (action.type) {
    case constants.GET_VIRTUALS_BY_PRODUCT_ID_SUCCESS:
    case constants.GET_VIRTUALS_SUCCESS:
      return Object.assign({}, state, {
        virtuals: action.virtuals.data || [],
        isRefreshRequired: false,
      });
    case constants.POST_VIRTUAL_SUCCESS:
      return Object.assign({}, state, {
        newVirtualId: action.virtual.data,
        isRefreshRequired: true,
      });
    case constants.PATCH_VIRTUAL_SUCCESS:
    case constants.PUT_STOP_SUCCESS:
      return Object.assign({}, state, {
        isRefreshRequired: true,
      });
    case constants.CREATE_NEW_VIRTUAL_SUCCESS:
    case constants.GET_VIRTUAL_SUCCESS:
      return Object.assign({}, state, {
        virtual: action.virtual.data || {},
        isRefreshRequired: false,
      });
    case constants.GET_VIRTUALS_BY_PRODUCT_ID_ERROR:
    case constants.GET_VIRTUALS_ERROR:
    case constants.GET_VIRTUAL_ERROR:
    case constants.POST_VIRTUAL_ERROR:
    case constants.PATCH_VIRTUAL_ERROR:
    case constants.PUT_STOP_ERROR:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}
